module.exports = __webpack_public_path__ + "assets/img/17.e38ecd0d.png";